export default __webpack_public_path__ + "static/media/small-game@2x.f516e94f.jpg";